module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "tlHeader",
    style: (_vm.getStyle),
    attrs: {
      "id": "rulerHeader"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tlHeaderText",
    staticStyle: {
      "font-size": "12px",
      "margin": "auto"
    }
  }, [_vm._v("教室"), _c('br'), _vm._v("＼"), _c('br'), _vm._v("時刻")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42fb67fb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42fb67fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/RulerHeader.vue
// module id = 698
// module chunks = 0